import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FacebookShareCount from 'react-share/lib/FacebookShareCount';
import PinterestShareCount from 'react-share/lib/PinterestShareCount';
import RedditShareCount from 'react-share/lib/RedditShareCount';
import TumblrShareCount from 'react-share/lib/TumblrShareCount';

import FacebookShareButton from 'react-share/lib/FacebookShareButton';
import LinkedinShareButton from 'react-share/lib/LinkedinShareButton';
import TwitterShareButton from 'react-share/lib/TwitterShareButton';
import PinterestShareButton from 'react-share/lib/PinterestShareButton';
import TelegramShareButton from 'react-share/lib/TelegramShareButton';
import WhatsappShareButton from 'react-share/lib/WhatsappShareButton';
import RedditShareButton from 'react-share/lib/RedditShareButton';
import EmailShareButton from 'react-share/lib/EmailShareButton';
import TumblrShareButton from 'react-share/lib/TumblrShareButton';

import FacebookIcon from 'react-share/lib/FacebookIcon';
import TwitterIcon from 'react-share/lib/TwitterIcon';
import LinkedinIcon from 'react-share/lib/LinkedinIcon';
import PinterestIcon from 'react-share/lib/PinterestIcon';
import TelegramIcon from 'react-share/lib/TelegramIcon';
import WhatsappIcon from 'react-share/lib/WhatsappIcon';
import RedditIcon from 'react-share/lib/RedditIcon';
import TumblrIcon from 'react-share/lib/TumblrIcon';
import EmailIcon from 'react-share/lib/EmailIcon';

import './ShareButtons.css';

class ShareButtons extends Component {
  static propTypes = {
    shareUrl: PropTypes.string,
    shareTitle: PropTypes.string,
    sharePicture: PropTypes.string,
  }

  render() {
    const { shareUrl, shareTitle, sharePicture } = this.props;
    const size = 53;
    return (
      <div className="share-container">
        <div className="share">
          <FacebookShareButton
            url={shareUrl}
            quote={shareTitle}
            className="share-button">
            <FacebookIcon
              size={size}
              round />
          </FacebookShareButton>

          <FacebookShareCount
            url={shareUrl}
            className="share-count"
          />
        </div>

        <div className="share">
          <TwitterShareButton
            url={shareUrl}
            title={shareTitle}
            className="share-button">
            <TwitterIcon
              size={size}
              round />
          </TwitterShareButton>
        </div>

        <div className="share">
          <TelegramShareButton
            url={shareUrl}
            title={shareTitle}
            className="share-button">
            <TelegramIcon size={size} round />
          </TelegramShareButton>
        </div>

        <div className="share">
          <WhatsappShareButton
            url={shareUrl}
            title={shareTitle}
            separator=":: "
            className="share-button">
            <WhatsappIcon size={size} round />
          </WhatsappShareButton>
        </div>

        <div className="share">
          <LinkedinShareButton
            url={shareUrl}
            title={shareTitle}
            windowWidth={750}
            windowHeight={600}
            className="share-button">
            <LinkedinIcon
              size={size}
              round />
          </LinkedinShareButton>
        </div>

        <div className="share">
          <PinterestShareButton
            url={String(window.location)}
            media={`${sharePicture}`}
            windowWidth={1000}
            windowHeight={730}
            className="share-button">
            <PinterestIcon size={size} round />
          </PinterestShareButton>

          <PinterestShareCount
            url={shareUrl}
            className="share-count"
          />
        </div>


        <div className="share">
          <RedditShareButton
            url={shareUrl}
            title={shareTitle}
            windowWidth={660}
            windowHeight={460}
            className="share-button">
            <RedditIcon
              size={size}
              round />
          </RedditShareButton>

          <RedditShareCount
            url={shareUrl}
            className="share-count"
          />
        </div>

        <div className="share">
          <TumblrShareButton
            url={shareUrl}
            title={shareTitle}
            windowWidth={660}
            windowHeight={460}
            className="share-button">
            <TumblrIcon
              size={size}
              round />
          </TumblrShareButton>

          <TumblrShareCount
            url={shareUrl}
            className="share-count"
          />
        </div>

        <div className="share">
          <EmailShareButton
            url={shareUrl}
            subject={shareTitle}
            className="share-button">
            <EmailIcon
              size={size}
              round />
          </EmailShareButton>
        </div>
      </div>
    );
  }
}

export default ShareButtons;
